import styled from 'styled-components';
import { ImageUtils } from '../../utils/ImageUtils';
import { mobileQuery } from '../../utils';

export const Header = () => {
  return (
    <HeaderContainer>
      <LogoContainer>
        <Logo src={ImageUtils.Logo} />
      </LogoContainer>
      <Table>
        <colgroup>
          <col style={{ width: '50%' }} />
          <col style={{ width: '50%' }} />
        </colgroup>
        <thead>
          <tr>
            <TableHeader>새틀라이트</TableHeader>
            <TableHeader>메인 이벤트</TableHeader>
          </tr>
        </thead>
        <tbody>
          <tr>
            <TableCell1>
              <TableTopText>
                11월 3일<span>(월)</span>~12월 4일<span>(목)</span>
                <br />
                <strong>매일 오후 6시 30분, 9시</strong>
                <CenterRow>
                  <img src={ImageUtils.ShowDownApp} alt="" />
                  <TableBottomTex>피망 쇼다운 홀덤 앱 진행 </TableBottomTex>
                </CenterRow>
              </TableTopText>
            </TableCell1>
            <TableCell1>
              <TableTopText>DAY1 12월 7일(일)</TableTopText>
              <CircleText>JP 스타디움</CircleText>
              <LocationText>
                NLH Main Event Day 1,
                <br />
                (SHOWDOWN HOLDEM Online Qualifiers)
              </LocationText>
            </TableCell1>
          </tr>
        </tbody>
      </Table>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  ${mobileQuery} {
    padding: 0 5px;
    padding-top: 39px;
  }
`;

const Logo = styled.img`
  width: 550px;
  ${mobileQuery} {
    width: 293px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  padding-top: 36px;
  position: relative;
  margin-bottom: 18px;

  ${mobileQuery} {
    padding-top: 0px;
    margin-bottom: 2px;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  margin-bottom: 10px;
  position: relative;

  ${mobileQuery} {
    margin-bottom: 5px;

    tbody {
      height: 108px;
    }
  }
`;

const TableHeader = styled.th`
  border-top: 2px solid #679cff;
  background: #2c52b3;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.1);

  color: rgba(255, 255, 255, 0.8);
  height: 30px;
  text-align: center;
  font-weight: 400;
  font-size: 20px;

  ${mobileQuery} {
    font-size: 13px;
    height: 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.4);
  }
`;

const TableCell = styled.td`
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
  letter-spacing: -0.05em;

  color: rgba(255, 255, 255, 0.7);

  ${mobileQuery} {
    font-size: 12px;
    line-height: 20px;
  }
`;

const TableCell1 = styled(TableCell)`
  vertical-align: middle;

  ${mobileQuery} {
    vertical-align: top;
  }
`;

const CenterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    margin-right: 10px;
  }

  margin-bottom: 14px;
  margin-top: 14px;

  ${mobileQuery} {
    margin-top: 7px;
    margin-bottom: 20px;

    img {
      width: 25px;
    }
  }
`;

const TableTopText = styled.div`
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  line-height: 30px;
  margin-top: 10px;

  strong {
    color: rgba(255, 255, 255, 0.6);
    font-size: 22px;
    font-weight: 400;
    line-height: 30px;
  }

  span {
  }

  ${mobileQuery} {
    font-size: 16px;
    line-height: 20px;
    margin-top: 10px;

    span {
      font-size: 14px;
      line-height: 20px;
    }

    strong {
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

const TableBottomTex = styled.p`
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px; /* 140% */

  ${mobileQuery} {
    font-size: 12px;
    line-height: 14px;
  }
`;

const CircleText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  display: inline-block;

  text-align: center;
  font-size: 20px;
  font-weight: 400;
  line-height: 31px;
  height: 31px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 30px;
  margin-top: 8px;
  margin-bottom: 6px;
  padding-left: 20px;
  padding-right: 20px;

  ${mobileQuery} {
    font-size: 12px;
    line-height: 20px;
    height: 20px;
    margin-top: 4px;
    margin-bottom: 4px;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const LocationText = styled.p`
  color: rgba(255, 255, 255, 0.6);

  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  ${mobileQuery} {
    font-size: 12px;
    line-height: 14px;
  }
`;

const OnlyWebBr = styled.br`
  display: block;

  ${mobileQuery} {
    display: none;
  }
`;
const OnlyMobileBr = styled.br`
  display: none;

  ${mobileQuery} {
    display: block;
  }
`;
